import { useState } from 'react'
import { REGEXP } from '../constants'

export function useResetPassFormValidation(formState, setIsInvalid) {
   const [formData, setFormData] = formState
   const [showPassRequirements, setShowPassRequirements] = useState(false)

   function setValue(event) {
      const { name, value } = event.target
      isPasswordFieldInvalid(name, value)
      setFormData(previous => ({
         ...previous,
         [name]: value
      }))
   }

   function isPasswordFieldInvalid(name, value) {
      let isInvalid = false
      let errorMessage = ''

      if (value === '') {
         isInvalid = true
         errorMessage = 'El campo es obligatorio'
         setShowPassRequirements(false)
      } else if (!REGEXP.PORTAL_PASSWORD.exec(value) && name !== "currentPassword") {
         isInvalid = true
         setShowPassRequirements(true)
      } else {
         setShowPassRequirements(false)
         if (name === 'currentPassword') {
            if (formData.newPassword) {
               const isNewInvalid = isInvalid || value === formData.newPassword
               let newErrorMessage = ''
               if (isNewInvalid) {
                  newErrorMessage =
                     'La nueva contraseña no puede ser igual a la actual'
               }
               setIsInvalid(previous => ({
                  ...previous,
                  newPassword: {
                     isInvalid: isNewInvalid,
                     errorMessage: newErrorMessage
                  }
               }))
            }
         }
         if (name === 'newPassword') {
            if (formData.currentPassword) {
               isInvalid = isInvalid || value === formData.currentPassword
               if (isInvalid) {
                  errorMessage =
                     'La nueva contraseña no puede ser igual a la actual'
               }
            }
            if (formData.confirmPassword) {
               const isConfirmInvalid =
                  isInvalid || value !== formData.confirmPassword
               let confirmErrorMessage = ''
               if (isConfirmInvalid) {
                  confirmErrorMessage = 'Las contraseñas no coinciden'
               }
               setIsInvalid(previous => ({
                  ...previous,
                  confirmPassword: {
                     isInvalid: isConfirmInvalid,
                     errorMessage: confirmErrorMessage
                  }
               }))
            }
         }
         if (name === 'confirmPassword') {
            isInvalid = isInvalid || value !== formData.newPassword
            if (isInvalid) {
               errorMessage = 'Las contraseñas no coinciden'
            }
         }
      }

      setIsInvalid(previous => ({
         ...previous,
         [name]: {
            isInvalid,
            errorMessage
         }
      }))

      return isInvalid
   }

   function isAnyPasswordFieldInvalid() {
      let isInvalid = false
      Object.keys(formData).forEach(name => {
         const value = formData[name]
         const isCurrentFieldInvalid = isPasswordFieldInvalid(name, value)
         isInvalid = isInvalid || isCurrentFieldInvalid
      })
      return isInvalid
   }

   return {
      setValue,
      isAnyPasswordFieldInvalid,
      showPassRequirements,
      setShowPassRequirements
   }
}
